import UserTypeActionTypes from "./userType.types";

/** ***************** GET UserType LIST START *********************** */
export const getUserTypeListStart = (getData: any) => ({
  type: UserTypeActionTypes.GET_USERTYPE_LIST_START,
  payload: getData,
});

export const getUserTypeListSuccess = (successData: any) => ({
  type: UserTypeActionTypes.GET_USERTYPE_LIST_SUCCESS,
  payload: successData,
});

export const getUserTypeListFailure = (failureData: any) => ({
  type: UserTypeActionTypes.GET_USERTYPE_LIST_FAILURE,
  payload: failureData,
});

export const getUserTypeListResponseResetStart = () => ({
  type: UserTypeActionTypes.GET_USERTYPE_LIST_RESPONSE_RESET,
});

export const getUserTypeListResponseChanged = () => ({
  type: UserTypeActionTypes.GET_USERTYPE_LIST_RESPONSE_CHANGED,
});

/** ***************** GET UserType LIST END *********************** */

/** ***************** ADD UserType DETAILS START *********************** */
export const addUserTypeDetailsStart = (addData: any) => ({
  type: UserTypeActionTypes.ADD_USERTYPE_DETAILS_START,
  payload: addData,
});

export const addUserTypeDetailsSuccess = (successData: any) => ({
  type: UserTypeActionTypes.ADD_USERTYPE_DETAILS_SUCCESS,
  payload: successData,
});

export const addUserTypeDetailsFailure = (failureData: any) => ({
  type: UserTypeActionTypes.ADD_USERTYPE_DETAILS_FAILURE,
  payload: failureData,
});

export const addUserTypeDetailsResponseResetStart = () => ({
  type: UserTypeActionTypes.ADD_USERTYPE_DETAILS_RESPONSE_RESET,
});

export const addUserTypeDetailsResponseChanged = () => ({
  type: UserTypeActionTypes.ADD_USERTYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD UserType DETAILS END *********************** */

/** ***************** UPDATE UserType DETAILS START *********************** */
export const updateUserTypeDetailsStart = (updateData: any) => ({
  type: UserTypeActionTypes.UPDATE_USERTYPE_DETAILS_START,
  payload: updateData,
});

export const updateUserTypeDetailsSuccess = (successData: any) => ({
  type: UserTypeActionTypes.UPDATE_USERTYPE_DETAILS_SUCCESS,
  payload: successData,
});

export const updateUserTypeDetailsFailure = (failureData: any) => ({
  type: UserTypeActionTypes.UPDATE_USERTYPE_DETAILS_FAILURE,
  payload: failureData,
});

export const updateUserTypeDetailsResponseResetStart = () => ({
  type: UserTypeActionTypes.UPDATE_USERTYPE_DETAILS_RESPONSE_RESET,
});

export const updateUserTypeDetailsResponseChanged = () => ({
  type: UserTypeActionTypes.UPDATE_USERTYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE UserType DETAILS END *********************** */

/** ***************** DELETE UserType DETAILS START *********************** */
export const deleteUserTypeDetailsStart = (deleteData: any) => ({
  type: UserTypeActionTypes.DELETE_USERTYPE_DETAILS_START,
  payload: deleteData,
});

export const deleteUserTypeDetailsSuccess = (successData: any) => ({
  type: UserTypeActionTypes.DELETE_USERTYPE_DETAILS_SUCCESS,
  payload: successData,
});

export const deleteUserTypeDetailsFailure = (failureData: any) => ({
  type: UserTypeActionTypes.DELETE_USERTYPE_DETAILS_FAILURE,
  payload: failureData,
});

export const deleteUserTypeDetailsResponseResetStart = () => ({
  type: UserTypeActionTypes.DELETE_USERTYPE_DETAILS_RESPONSE_RESET,
});

export const deleteUserTypeDetailsResponseChanged = () => ({
  type: UserTypeActionTypes.DELETE_USERTYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE UserType DETAILS END *********************** */

/** ***************** FETCH UserType DETAILS START *********************** */
export const fetchUserTypeDetailsStart = (fetchData: any) => ({
  type: UserTypeActionTypes.FETCH_USERTYPE_DETAILS_START,
  payload: fetchData,
});

export const fetchUserTypeDetailsSuccess = (successData: any) => ({
  type: UserTypeActionTypes.FETCH_USERTYPE_DETAILS_SUCCESS,
  payload: successData,
});

export const fetchUserTypeDetailsFailure = (failureData: any) => ({
  type: UserTypeActionTypes.FETCH_USERTYPE_DETAILS_FAILURE,
  payload: failureData,
});

export const fetchUserTypeDetailsResponseResetStart = () => ({
  type: UserTypeActionTypes.FETCH_USERTYPE_DETAILS_RESPONSE_RESET,
});

export const fetchUserTypeDetailsResponseChanged = () => ({
  type: UserTypeActionTypes.FETCH_USERTYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH UserType DETAILS END *********************** */
